export interface IKeyValue {
    key: any;
    value: any;
}
